import * as React from 'react';

export const useIsDatabasePage = (pathname: string): boolean =>
  React.useMemo(() => /^\/database/.exec(pathname) !== null, [pathname]);
